import React from 'react';
// import programheadshot from '../images/programheadshot.jpg';
// import nineJohnson from '../images/9Johnson.jpg';
import {
  PageContent,
  ContentBox,
  NewsClipping,
  Notice
} from '../css/_styledComponents';
import souvenirBlackHawksPhoto from '../images/souvenirBlackHawksPhoto.jpg';
import podium from '../images/familyphotos/podium.jpg';
import Figure from '../components/Figure';
import vjMillers from '../images/familyphotos/VJ_millers.jpg';
import StPaulMunincipalAudtorium from '../images/StPaulMunincipalAudtorium.jpg';
import SaintPaulSaints_1935 from '../images/SaintPaulSaints_1935.jpg';
import OwnerFredericandIrene from '../images/familyphotos/OwnerFredericandIrene.jpg';
import chicagostadium from '../images/chicagostadium.jpg';
import virgiljohnson_blackhawks_1938 from '../images/familyphotos/virgiljohnson_blackhawks_1938.jpg';
import theSaints from '../images/stPaulSaints-1941.jpg';
import hersheyBears_1943 from  '../images/hersheyBears_1943.jpg';
import hotel from '../images/familyphotos/hotel.jpg';
import blackhawksprogram300 from '../images/familyphotos/blackhawksprogram300.jpg';
import blackhawks1944 from '../images/blackhawks-1944-45.jpg';
import blackhawks from '../images/familyphotos/blackhawks.jpg';
import farewellFest from '../images/farewellFest.jpg';
import vj11 from '../images/familyphotos/VJ_11.jpg';
import flyingPuck from '../images/flyingPuck.svg';
import FidoCullyVirg from '../images/FidoPurpur_CullyDahlstrom_VirgJohnson-Chicago-1940.jpg'
import virgAndGovernorWendellAnderson from '../images/virgAndGovernorWendellAnderson.jpg';

function Career () {
  return (
    <PageContent>
      <ContentBox type="white">
        <Figure
          fullWidth
          img={souvenirBlackHawksPhoto}
        />
      </ContentBox>
      <ContentBox type="white">
        {/* <figure style={{ float: 'left' }}>
          <img src={programheadshot} width="194" height="283" alt="Virgil Johnson Program Headshot 1944" />
          <figcaption>Stadium Program Feb 1944</figcaption>
        </figure> */}

        <h2>
          The United States Hockey Hall of Fame Eveleth MN 1974
        </h2>
        <Figure
          left
          img={podium}
          caption='Virg&apos;s acceptance speech, Hockey Hall of Fame 1974'
        />
        <p>
          Virgil Johnson was inducted into the United States Hockey Hall of Fame in October 1974. This
          honor recognized his commitment to the sport and the talent that supported his career from
          1930 to 1952.
          He was one of the longest serving American defensemen of this early sports era.
          {' '}
        </p>
        <p>
          The highlight of his career was as a member of the noted 1937-38 Chicago Black Hawks
          &quot;Cinderella&quot; team (NHL) in the Stanley Cup playoffs. This team featured several
          home grown American boys, many of whom, like Johnson were from Minnesota. With a combination
          of luck, skill, and pluck the Hawks skated to victory over the Toronto Maple Leafs.
          Johnson played seven of those Stanley Cup games and became the only defenseman in NHL
          history to get a penalty shot during a Stanley Cup Series.
          {' '}
        </p>
        {
          /*
          <p>
            Born in Minneapolis, Johnson played for the Minneapolis Millers (CHL) for several
            seasons in the 1930&apos;s. But his reputation more significantly rested with the St. Paul
            Saints (CHL/AHA) for whom he played eight seasons. He was a fixture on defense and was named
            to the AHA first all-star team in 1942.
          </p>
          <figure style={{ float: 'right' }}>
            <img src={nineJohnson} width="194" height="296" alt="Virgil Johnson Kansas City Americans" />
            <figcaption>Kansas City Americans</figcaption>
          </figure>
          <p>
            During the war years he moved back and forth across the country playing for the Hershey
            Bears (AHL), Chicago Black Hawks (NHL), Kansas City Americans (AHA), and the Cleveland Barons
            (AHL). He returned to the Chicago Black Hawks for the 1943-44 season, playing all 48 games.
            He began the 1944-45 season but played only two games before he was sent back to the AHL
            with the Cleveland Barons.
          </p>
          <p>
            His career in the late 1940&apos;s saw him returning to the Minneapolis Millers (USHL),
            Minneapolis Jerseys (AAHL) and St. Paul Saints (AAHL). These latter years were also spent
            coaching, notably for Rochester&apos;s fledgling hockey team. Despite press praise that
            &quot;Virg is better now than he ever was&quot; Johnson retired from the rink in 1952 making
            him one of the longest serving American players of the first half of the twentieth century.
          </p>
          */
        }
      </ContentBox>




      <ContentBox>
        <h2>
         Hockey years on the ice 1930-1952
        </h2>
        <p>
          Virg received athletic scholarship offers from the University of Minnesota 
          and Notre Dame but declined them to earn money during the Great Depression and play hockey.  In 1930, 
          Johnson joined the Millers to become one of the league&apos;s outstanding performers. 
          The season was only half over when he wrote to the Black Hawks asking for a try out. 
          He was invited by Bill Tobin in September 1931 &quot;to show your ability&quot; and got his first 
          introduction to professional hockey by joining the Chicago Black Hawks &quot;on trial&quot;. 
        </p>
        <blockquote cite ='waka foo'>
          Surrounded by more than a score of well wishers, including his teammates, he boarded a train 
          for Chicago and his new hockey job with the Black Hawks.  On his arrival in Chicago today, 
          Johnson was to go through the usual &apos;Get Acquainted&apos; ceremonies with his new mates. 
          He will take daily workouts with the Hawks at once.
          <span className="cite">- Star Tribune 2/13/1931</span>
        </blockquote>
        <p>
          He remained in the Windy City through the season, however, he failed to get a call to 
          report to the national leaguers the following season. But he overcame that disappointment 
          &quot;to star through two Central league seasons and start the present one with more 
          brilliant performances.&quot; 1/18/1934
        </p>
      </ContentBox>


      <ContentBox type="white">
        <h2>
         Minneapolis Millers 1930-1934
        </h2>
        <Figure
          left
          style={{ flex: '1', margin: '20px', color: 'var(--color-cream)' }}
          img={vjMillers}
          caption="Virg Johnson Minneapolis Millers, 1934"
        />
        <p>
          Virg was hired by the Minneapolis Millers to play defense for the 1930-1934 
          seasons. &quot;A 23-year-old product of the sandlots who scales a measly 
          155 pounds and can take the bumps with the rest of them.  He is Virgil 
          Sylvester Johnson the dashing, crashing Scandinavian defense star of the 
          Minneapolis Millers who is a midget compared with the bruising 180 and 200 
          pounders on clubs throughout the Central league.  He is the smallest defenseman 
          in Central Hockey league competition.&quot; &quot;Some three or four seasons back, 
          Virgil Johnson was a great North High fooball performer but regarded as only 
          an ordinary hockey player.  Today he is regarded as one of the Central Hockey 
          League&apos;s outstanding defensemen and most colorful performers.  He is captain 
          of the Miller six that faces the Hibbing club in an important tilt Sunday. 
          And he&apos;s the favorite among many a fan.&quot; 1/19/1931. 
        </p>
        <p>
          &quot;Most of Johnson&apos;s scoring in the last 10 games has been attributable to 
          some brilliant work on defense.  Checking oponent&apos;s rushes in his usual 
          capable manner, Johnson has developed into one of the fastest breaking performers 
          in the loop.&quot;  Inspite of praise citing the Millers &quot;bladed gem&quot; and 
          heralded as the &quot;most effective offensive player during the Miller win 
          streak,&quot; headlines in November 1934 read, &quot;Saints sign Virgil Johnson&quot;. 
          &quot;A rush of new stength to the St. Paul hockey team of the Central League less 
          than a week before the season is scheduled to open here resulted in the signing 
          Tuesday of Virgil Johnson, defense star last season with the Minneapolis Millers.&quot;
        </p>
      </ContentBox>

      <ContentBox>
        <h2>
         St Paul Saints 1934-1937
        </h2>
        <Figure
          fullWidth
          img={StPaulMunincipalAudtorium}
          caption="St. Paul Munincipal Audtorium, home of the St. Paul Saints"
        />
        <p>
          The St. Paul Saints sign up Virg.  &quot;Acquisition of Johnson was expected for a 
          couple of days since Lyle Wright offered his holdout performer to the Saints 
          in a straight cash deal.&quot; 11/1934.  P.S. Please note that Virg's Central Hockey 
          League contract for 1935-36 offered team employment from 26 November to 1 April 
          for a weekly salary of $50.00.  These were the Depression years.    
          &quot;No team comes along with a better pair of defensemen than Emil Hansen and 
          Virg Johnson of St. Paul, the fans here will pack the Auditorium to see them.&quot;
          &quot;Johnson's scoring pace this season was too hot for 
          most of the forwards of the circuit--he was the leading defenseman in point 
          making.&quot;  Both Emil and Virg were awarded places in 1935-36 on the American 
          Hockey Association (AHA) all-star team, picked by the Pioneer Press and Dispatch. 
          Virg remained with the St. Paul Saints from 1934 to 1937 when he was scouted 
          for the Chicago Black Hawks.
        </p>
        <p>
          His fellow teamates on the Millers and Saints all went on to become stars in 
          various leagues; Cliff &quot;Fido&quot; Purpur, Hub Nelson, Donnie Olson, Earl 
          Bartholome, Jack Flood, Bill Oddson, Ted Breckheimer, Evy Scotvold, Emil 
          Hanson, and Kelly Ness. 
          Virg was paired with Bill McGlone, &quot;small parcels of dynamite&quot;, becoming 
          the &quot;lightest defensive pair in the Central League.&quot;  None were more 
          respected than Minneapolis&apos; 165 pounds of &quot;fighting Irish&quot; and 
          155 pounds of &quot;durable Norse.&quot; But it was his defense assists with Cully 
          Dahlstrom that excited fans and made a lifelong pal.  &quot;Johnson stopped 
          the puck carrier and swept past the Saints&apos; defense before passing to 
          Cully Dahlstrom who rammed the disc home.&quot; 
        </p>
        <Figure
          fullWidth
          img={SaintPaulSaints_1935}
          caption="The Winning Team Period 3, 8 to 2.  Saint Paul Saints of the Central Hockey League, 1935.  Virg is second player from left, Cully Dahlstrom is the 5th player from the left"
        />
      </ContentBox>

      <ContentBox type="white">
        <h2>The Chicago Black Hawks (THE CINDERELLA TEAM) 1937-1938</h2>
        <Figure
          right
          img={OwnerFredericandIrene}
          caption='Owner Frederic and Irene (Castle) McLaughlin Lake Forest, IL c. 1930'
        />
        <p>
          Chicago millionaire, Frederic McLaughlin, was a man of ambitious hockey enthusiasm.
          He envisioned an All American Team to people his prized but struggling Chicago
          Black Hawks. It was a long shot. &quot;Think of what that will mean to attendance.
          American cities will be represented by American players.&quot; Thank you Frederic! Minnesotans
          were represented by Mike Karakas (goalie), Doc Romnes (center), Cully Dahlstrom
          (forward), and Virgil Johnson (defense). McLaughlin&apos;s wife, Broadway
          dancer Irene Castle, designed the new team&apos;s jerseys. The profile
          of the head of a Blackhawk Indian had floppy feathers over his ears. The
          players disliked the jersey&apos;s Indian profiles intensely but said nothing outside of the locker
          room. They all were charmed by Irene and would not bite the hand that fed
          them. When Virg returned to the Black Hawks in 1943, the jerseys had been
          redesigned. The hockey management outfitted the team for combat. Virg wore a size
          &quot;6 1/2 wide shoe&quot; and had his skates specially made by the Nestor
          Johnson Skate Company, a sponsor for the Black Hawks.
        </p>
      </ContentBox>


      <ContentBox>
        <Figure
          left
          img={chicagostadium}
          caption='The Chicago Stadium Curt Teich &amp; Co Postcard 1938'
        />
        <p>
          Equally admired was the new Art Deco hockey arena designed by Hall, Lawrence,
          &amp; Ratcliffe, Inc.  The price tag was 9.5 million. The Chicago Stadium, located
          at Madison, Wood, Warren and Wolcott Streets, was the largest sports arena
          in the world with a seating capacity for 25,000 persons. One feature of
          the huge auditorium was a giant pipe organ that was suspended over the rink.
          From here a heavyset contralto could invite team combat by belting out
          {' '}
          <em>
            The
            Star Spangled Banner.
            {' '}
          </em>
        </p>
        <p>
          William J. Stewart was a longtime sports figure in baseball and hockey. 
          In 1928 he became the first American born referee in the NHL. McLaughlin 
          tapped him in 1937 to coach his new &quot;American Team.&quot;  In spite of a few 
          notable Canadian carryovers in Art Wiebe and Earl Seibert, the team had 
          eight Americans, four native born, on it&apos;s new roster.  The Cinderella Team.  Would the slipper 
          fit? In the long season ahead, the team was &quot;a long shot&quot; but shut out the 
          Montreal Canadians in a 3-2 overtime win. The New York Americans went the 
          same way in game 3 losing 3-2 at Madison Square Garden. This win sent the 
          Black Hawks up against the powerful Toroto Maple Leafs, the winner would 
          take Lord Stanley&apos;s Cup.
        </p>
      </ContentBox>

      <ContentBox type="white">
        <Figure
          right
          img={virgiljohnson_blackhawks_1938}
          caption='Virg Chicago Black Hawks 1937-38'
        />
        <p>
          The irascable Coach, Bill Stewart, had his hands full in the final set of playoffs. 
          Goaltender Mike Karakas fractured his toe in the battle with the Americans and 
          couldn&apos;t play. Alfie Moore, was pulled out of a Toronto pub to tend goal and 
          shocked the Leafs by a 3-1 win in the opening game at the Maple Leaf Gardens. 
          The Hawks lost in Game 2. &quot;Iron&quot; Mike returned in Game 3 wearing a steel capped 
          boot and winning 2-1. Doc Romnes was wearing a football helmet to protect his 
          broken nose and fractured jaw. Ouch! A record overthrow throng of 18,497 
          fans crowded into the Chicago Stadium for the Black Hawks winning game 3 on April 10th.
        </p>
        <p>
          The New York Times, April 13, 1938. &quot;Black Hawks Beat Maple Leafs and Take Stanley 
          Cup Series 3 Games to 1. 17,204 See Chicago Score 4-1 Triumph. Rapid-Fire Goals 
          by Voss and Schill in Second Beat Leafs for World Hockey Title. Dahlstrom nets in first. 
          But Drillon of Toronto Evens Count - Hawk&apos;s Victory Caps Post-Season Upsets.&quot;  
          &quot;The indomonitable Chicago Black Hawks, one of the longest long shots in all sports 
          history, scored in every period tonight to defeat the Toronto Maple Leafs, 4 to 1, 
          to win the Stanley Cup and world hockey championship before 17,204 spectators at the 
          Chicago Stadium.&quot; &quot;Goalie Mike Karakas, fought off desperate Leaf bids which had the 
          crowd in a constant uproar.&quot; The win triggered a rattle of chair seats and a 
          volcano of cheers. After the final whistle, &quot;as the cup was presented to the almost 
          hysterical Hawks, the Leaf personnel congratulated the victors.&quot;
        </p>
        <p>
          However, the Andy Frain ushers at the Stadium saw more than winning scores and
          frenzied fans. The Chicago Tribune on April 13 noted that the Frain ushers had
          fleeced the crowd of &quot;ice ammunition&quot; as varied as &quot;marbles, bags of rice
          and flour, one thousand paper airplanes (scooters), pennies in 25 cent
          rolls, coat hangers, and folding chairs,&quot; in a search and seizure
          act before the game.
        </p>
        <p>
          Virg played seven of those Stanley Cup games and became the only defenseman in NHL history
          to get a penalty shot during a Stanley Cup Series. This victorious 1937-38
          &quot;Cinderella&quot; team was the first All-American Team to win the Cup. Quoting
          Johnny Gottselig, &quot;so all we did was go out and win the Stanley Cup&quot;. It would
          be another 23 years before the Hawks captured the cup again.
        </p>
      </ContentBox>

      <ContentBox>
        <p>
          PUCKSTRUCK, the painful arthritis that resulted in Virg&apos;s knobby knuckles
          and elbows and that affected his walking increased with the passing years. Virg 
          played hockey at a time when agility and skill were much admired. The old hockey
          uniforms were under-padded. Helmets were by and large not worn by the players. An award, 
          the Lady Byng Trophy, used to be presented annually to the player who best 
          demonstrated true sportsmanship and gentlemanly conduct while showing consistent 
          skill in handling the puck. Virg was never a candidate for gentlemanly conduct. 
          But Doc Romnes was a recipient. In the final Black Hawk games against Toronto in 1938
          Doc encountered defenseman, Red Hoerner, who broke his nose in five places.
          Hockey can be a violent game. Mike Karakas goaled in &apos;38 with a
          fractured toe encased in a cast. And Virg, like most other team members,
          played games wearing his false teeth. While playing for the Black Hawks
          against Detroit, the referee&apos;s whistle stopped the action in response
          to Virg&apos;s screaming, &quot;I lof my teef!&quot; The crowd grew
          still and the players surrounded him. &quot;I lof my teef. Fomeone flamed
          me and my teef are gone,&quot; he said, pointing to his mouth. Both teams
          joined in a search, the crowd figuring out what had happened howled with
          laughter, but the search was fruitless. Virg was persuaded to continue
          playing. When the game was over, Virg did not return to the locker room
          but stayed on the rink as it was drained and gave a happy shout when he
          found them smiling up at him. Unperturbed, he snapped them back into his
          mouth, returned to the locker room and headed to the nearest steak joint.
        </p>
      </ContentBox>


      <ContentBox type="white">
        <h2>The St. Paul Saints 1938-1942</h2>
        <Figure
          fullWidth
          img={theSaints}
          caption='The St. Paul Saints 1941-42'
        />
        <p>
          &quot;Virg Johnson, all-star defenseman in the American Hockey Association for St. Paul 
          two of the past four seasons, came back to the Saints Saturday from the Chicago Black Hawks 
          of the National League to become coach of the St. Paul team. Virg was repurchased by 
          J. E. Goodwillie, president of the St. Paul Club.  He was too light for a major league 
          defense post, however, and when the Hawks decided to let him go this fall, Goodwillie put 
          in an immediate bid.  The first game will be a home affair with Minneapolis, coached by 
          Ching Johnson on 11/6.&quot; Tribune 10/23/1938.  Before that Virg &amp; Helen and Cully 
          &amp; Gladys vacationed over Labor Day on the North Shore.  Cully returned to Chicago and 
          had a disappointing year with the Black Hawks who did not have a winning season.
        </p>
        <p>
          HEADLINES &quot;Saint Pucksters go on Sit-Down Strike. Coach Virg Johnson at noon today 
          confirmed the report that most of the players had refused to leave town until salaries 
          were paid up-to-date.&quot; 1/23/1939. With money matters for back salaries and travel 
          expenses resolved, the team left for Kansas City. 
        </p>
        <p>
          The tide turned in 1940 for the Saints, &quot;One of the best defensemen in the American Hockey 
          Association, Virg Johnson, veteran star of the St. Paul club, jumped into the team scoring 
          leadership Sunday with a goal and an assist in the victory over Omaha. He will try for 
          more points at the Auditorium Thursday night against Minneapolis.&quot; St Paul Dispatch. 
          &quot;Virg Johnson AHA Most Valuable.&quot; &quot;Rewarded after seven years of stardom on 
          defense for the St. Paul Hockey club. Virg Johnson has been voted the most vauable player 
          in the American Hockey Association by a poll of team managers, coaches, and sports writers. 
          He has been one of the most popular players ever to perform for the Saints.&quot; 4/27/1942  
        </p>
      </ContentBox>

      <ContentBox type="black" style={{ color: 'var(--color-cream)'}}>
        <h2>The Hershey Bears 1943</h2>
        <Figure
          style={{ padding: '20px 0' }}
          fullWidth
          img={hersheyBears_1943}
          caption='The Hershey Bears 1943.  Virg seated left. Fred Hergert, player, standing 4th from left.'
        />
        <p>
          The American Hockey Association folded for the duration in 1943, that necessitated the move to Hershey, 
          Pennsylvania. The War years took a toll on players from the various national hockey teams. 
          Owners and Managers scrambled to put together star players for 
          winning wartime seasons. Virg was not called up for military service.  In a sense his 
          service was to bring United States PRIDE in the hockey arena to hometown sports fans. 
          &quot;The Hershey Bears Open Sixth American Hockey League Season Tonight in 
          Sports Arena.&quot; 10/30/1943.  &quot;Big gun of the Hershey defense is Virg Johnson, 
          who played as brilliantly for St. Paul for so many seasons while Freddie Hergert, 
          flashy center from St. Louis, is one of the Bears' leading point getters.&quot;
        </p>
        <p>
          Virg, Helen and Johnny lived on Chocolate Avenue. Helen hired an au pair, Mickey Nye, 
          to babysit Johnny while she did volunteer war work. Johnny was dressed in little army 
          and navy uniforms throughout the war.  Helen and Virg were a patriotic couple.
        </p>
      </ContentBox>


      <ContentBox>
        <h2>The Chicago Black Hawks 1943-1945</h2>
        <Figure
          right
          img={hotel}
          caption='Curteich Chicago postcard - 1943'
        />
        <p>
          Virg returned to the Chicago Black Hawks (NHL) for the 1943-44 Season. Virg,
          Helen, and Johnny lived with other team member&apos;s families at the Hotel Guyon,
          the &quot;Home of Homes&quot; that boasted &quot;every room with bath
          and shower&quot;. It was located at 4000 Washington Boulevard. The wartime
          accommodations were cramped by today&apos;s standards. Helen to Agnes on December
          16, &quot;We have a one room apartment to live in and I like it a lot... however,
          they have put our name on the list waiting for an apartment with a bedroom,
          as they are only $1.00 more a week, and it will be better for Johnny than
          sleeping on the davenport. This apartment has a real nice kitchen, large
          enough for Johnny and me to eat in.&quot; In March 1944 she wrote, &quot;After
          the game, I had a surprise 35<sup>th</sup> birthday party for Virg up in the Dahlstrom apartment.
          We played games and I served cold fried chicken, potato salad, coleslaw
          and hard rolls. The ten of us ate twelve pounds of chicken. Virgil got some
          wonderful birthday presents and won&apos;t have to buy a thing for ages.&quot;
        </p>
        <p>
          The teammates did not suffer in the wartime climate of rationing. The fans
          gave them food coupons in and around the stadium. Helen continued, &quot;We
          sure have been lucky at getting foodstuffs this winter. We have been invited
          out for buffalo, venison, and roast duck dinner and are going out Saturday
          for lobster.&quot; But rationing was no laughing matter. Virg wrote to
          his folks, &quot;enclosed are a couple of gas coupons.&quot; His fans
          volunteered more than food.
        </p>
        <p>
          Helen wrote to Agnes, &quot;We have been buying war bonds as fast as we can. 
          Johnny and Ruthie are almost inseparable, but he talks so much and so continuously 
          that she can hardly get a word in edgeways. And bossy!!! Today they went to dancing 
          school together, and when it gets sunny we are going to take them out to Lincoln 
          Park Zoo and next we are going to the Brookfield Zoo.&quot;
        </p>
      </ContentBox>


      <ContentBox type="black" style={{ color: 'var(--color-cream)'}}>
        <Figure
          fullWidth
          img={blackhawks1944}
          caption='Team Photo with Virg, Cully, and Fido 1944-1945'
        />
      </ContentBox>


      <ContentBox>
        <NewsClipping>
          <h2>
            OPEN TICKET SALES
          </h2>
          Ticket sales for the second and third games of the final series for the Stanley 
          Cup between the Chicago Black Hawks and the Montreal Canadiens to be played in the 
          Chicago Stadium next Thursday and Sunday, April 9, will go on sale at 
          Bond's, 65 W. Madison St. at 11 o'clock this morning.  These are the only games 
          of the title series scheduled for Chicago. 
        </NewsClipping>
        <Figure
          right
          img={blackhawksprogram300}
          caption='Virg Chicago Black Hawks 1944'
        />
        <p>
          &quot;VIRG JOHNSON SIGNS WITH HAWKS; DAHLSTROM HERE AS SQUAD HITS 16.&quot;   
          Reversal of war time rulings and other difficulties caused a sudden flurry and 
          search for replacements to enable the Hawks to put a strong team against the 
          Toronto Maple Leaves.  The Hawks &quot;Purchased Virgil Johnson, a former Hawk, who has 
          been the property of the Hershey Bears of the American League and St. Paul Saints 
          of the American Association.  Earl Seibert reported here Saturday.  Nothing has 
          been heard from Art Wiebe who indicated he was about to report.&quot; 10/30/1943.
        </p>
        <p>
          &quot;I saw the game Sunday night,&quot; Helen wrote to Agnes, &quot;took my kniting 
          along and almost got a mitten done.  Virgil got two assists so I was quite proud. 
          A lot of people think he should have had credit for one of the goals, but the referee 
          said that Bill Mosienko had deflected Virgil&apos;s shot into the net, so Virg got an assist. 
          His second assist came when he passed to Cully on his own blue line and Cully went down 
          and scored a beautiful solo shot to win the game.  Seemed like old times when they said, 
          &quot;Dahlstrom scoring on Johnson&apos;s assist'.&quot;&quot; 12/28/1943.
        </p>
        <p>
          &quot;Hawks, in 3rd-place Tie, await Boston Bruins.  This victory sent the Hawks into 
          a third-place tie with Toronto, moving them three games ahead of the Bruins, and only 
          two games out of second place&quot; 2/28/1944.  The pot began to boil when, 
          &quot;Montreal gained the windup spot with the Hawks by pulverising the Toronto Maple 
          Leafs 11 to 0.  The jubilant Hawks left for Chicago on a midnight train.  On Monday 
          they will go to Montreal for the first of the seven game series Tuesday night 
          against the Canadiens.  This is the first meeting in finals of the Hawks and 
          Canadiens since 1931.&quot;
        </p>
        <Notice>
          Because of the increasing scarcity of rubber, we would appreciate our patrons returning any 
          pucks that might be shot into the audience in order that we may be sure of enough to finish 
          the season. <span className="cite">- Signed, Chicago Black Hawks Management</span>
        </Notice>
      </ContentBox>

      <ContentBox type="white">
        <Figure
          left
          img={blackhawks}
          caption='Well fed and traveled Black Hawks at Chicago train station 1944'
        />
        <p>
          &quot;There was little joy in the City of Broad Shoulders with the news that the Hawks 
          had lost the first three games against the Montreal Canadiens in the Stanley Cup finals. 
          &quot;The Black Hawks are not finishing up so well,&quot; Helen wrote to Agnes on April 11, 
          &quot;they are going down ( I am afraid) four straight before Montreal.  At this moment 
          Montreal has won three straight and the team left today to play the fourth game 
          Thursday on Montreal ice.  As Montreal has been defeated on their own ice only once 
          this season, it does not look as though the Hawks would be able to win this one. 
          I did not expect them to defeat Montreal for the CUP but I sure did wish that they 
          would win at least one more game so that the series would be extended to five, 
          even seven, games because the boys are being paid on a per game basis and every 
          game adds just that much more to their checks.  Montreal really had a wonderful 
          club this year.  They play together like they were one man, their passing is 
          terrific, and their team play and backchecking something to be seen before it is 
          believed.&quot;
        </p>
        <h3>
          &quot;CANADIENS WIN CUP TITLE GAME 5-4, OVERTIME&quot;
        </h3>
        <p>
          Virg played nine of the final Stanley Cup games.  The Chicago program noted in 
          &quot;THE HAWK OF THE WEEK Johnson is not a defense player of the bone crushing type. 
          He is a good body checker and possesses enough speed to make him dangerous in a rush, 
          for he is an accurate passer and a good shot close in on the nets.&quot; 
          But following this season, Virg left the National Hockey League.
        </p>
      </ContentBox>


      <ContentBox>
        <h2>The Cleveland Barons 1945</h2>
        <p>
          As the World War was ending, the Johnson family next moved to Cleveland, Ohio. 
          Virg was &quot;obtained in December from the Chicago Black Hawks.&quot;  He would finish out 
          the 1944-1945 season playing for the Barons.  Al Sutphin, owner of the Cleveland 
          Barons would write later, &quot;In the year Virg played in Cleveland we arrived in the 
          playoffs.  Virg&apos;s contribution in our championship playoffs was simply magnificent. 
          Our club has been in 13 playoffs, and no player ever stood out during all that 
          time as did Virg in that series.&quot;  The team, coached by Bun Cook, won the 
          League Championship in 1945.
        </p>
        <p>
          &quot;Gentlemanly conduct&quot; was absent in a &quot;free for all&quot; on the ice 
          with the St. Louis Flyers.  The Flyers coach &quot;called the Barons &apos;Daisies&apos;... 
          and other things not as aromatic&quot;.  It was &quot;unquestionably the dirtiest 
          hockey game played here in long time!  McVeigh sent the battlers to the penalty box, 
          each with a five-minute sentence.&quot;  This riotous by-play entertained &quot;a 
          good mid-week crowd of 5,653, some of whom pelted the players with their programs.&quot;
        </p>
        <p>
          In Cleveland they were reunited with Earl and Lauretta Bartholome, longtime friends 
          from Minneapolis.  Earl was a multi-seasoned Baron, who &quot;made a goal on a 20 
          footer from straight out in front of goalie Nick Damore.&quot;  Virg and Earl worked 
          on the sideline for Tapco making component parts for wartime aircraft engines. 
          At the end of the season there was a farewell party at a local pub for Virg. 
          Helen who was expecting a baby did not attend. Lauretta wrote on the following photo, 
          &quot;Hello, Helen, I'm tight. Virg's really good and tight! Can't wait till we get home!!!&quot;
        </p>
        <Figure
          fullWidth
          img={farewellFest}
          caption='Farewell Fest: Virg standing (C), Earl on his left and Lauretta seated (C).'
        />
      </ContentBox>

      <ContentBox type="white">
        <Figure
          right
          img={vj11}
          caption='Virg, Minneapolis Millers 1945'
        />
        <h2>The Minneapolis Millers 1945-1947</h2>
        <p>
          Virgil returned to the Minneapolis Millers in 1945-1947, a team that 
          he had played for at the beginning of his hockey career.
          &quot;Virgil Johnson to join Millers. Virgil Johnson is coming back home, he has signed 
          to play with the Minneapolis hockey team and thereby completes his wanderings 
          and comes back to his native town conceivably with  a few years of good hockey left in 
          his body.&quot; Minneapolis Star Journal 10/18/1945. &quot;Home&quot; also included the 
          new bungalow at 6715 Nicollet Avenue South.
        </p>
        <p>
          Helen was anxious to cease the annual moves, put Johnny into a permanent school, and 
          tend to her new baby, Alan David Johnson, who was born on June 6, 1945.
          Both Helen and Virg loved Lake Minnetonka. They had summered at a cottage at Island Park 
          since their marriage.  Looking for a more permanent home, Virg renovated a summer cottage 
          into a year round &quot;rambler&quot; house at Tonka Bay, Lake Minnetonka, and the 
          &quot;retired&quot; hockey player and his family moved in in 1946.
        </p>
        <p>
          &quot;For our dough, on a pound-for-pound basis, Virg Johnson is the best defenseman this 
          league has seen in modern hockey.  Far from being a brute, he has mastered the adroitness 
          of blue line play and his poke or hook did as much damage in breaking up rushes as the 
          elaphantine work of the more burly boys.  Miller fans doubtless will welcome him back, 
          for it&apos;s a cinch the guy will be of help.&quot; 10/18/1945.
        </p>
        <p>
          &quot;Millers Rally to Tie Saints 2-2&quot; 1/12/1947.  It&apos;s worth noting, 
          &quot;The first period saw Virg Johnson, veteran Miller defenseman, draw the first 
          misconduct penalty of his professional career that covers some 15 years.&quot;  
          &quot;The Millers are still tied for first place with Omaha.  It was a furiously 
          played game from start to finish with the teams battling right down to the final 
          buzzer to break the tie.&quot;
        </p>
        <p>
          &quot;Virg Johnson Makes Play of the Year for Key Goal,&quot;  2/2/1947. &quot;Cutts 
          let fly a pass and the puck hit Virg&apos;s stick which he had cleverly placed 
          lengthwise along the ice.  The puck skipped into the open without a soul around 
          - except Virg who went after it.  This was a chance every hockey player dreams of 
          getting and Johnson didn&apos;t muff it.  He dribbled the disc the rest of the way 
          down the rink and stormed in on Bud LaMarche who didn&apos;t come out of the Tulsa nets. 
          Virg faked to the right and hit the left corner for a beautiful goal that sewed up the game.&quot;
        </p>
      </ContentBox>


      <ContentBox id="part3">
        <h2>Retirement 1952</h2>
        Virgil Johnson Set To Retire In Spring.
        <blockquote>
          Virgil Johnson is thinking seriously of retiring next April.  Not because the game has passed him.
          It&apos;s because he doesn&apos;t want to pass up a life-time job with Insulation Sales of Minneapolis,
          a busy concern which has given him a leave of absence to play one more season.
          The former North High halfback who turned pro in 1930, will take with him, when he retires,
          a sincere pat on the back from fans who can say he gave them more than their money&apos;s worth,
          even when his legs were not as springy as those of a rookie on the other side of the blue line.
          <span className="cite">- by Eddie T. Jones</span>
        </blockquote>
        <p>
          &quot;Always a good man with the stick when he was playing as a pro, Virg has lost
          none of his touch. As a matter of fact if you can believe a lot of fans he is
          getting better. An old sidekick of pro days who was a playing foe, the now ageless Earl
          Bartholome, claims &apos;Virg is better now than he ever was.&apos;.&quot; This
          St. Paul Dispatch article from January 9, 1952 claimed Virg &quot;Refutes
          Hockey Age Theories&quot;. He had played and coached
          in Rochester in 1951 but in 1952 Virg was 42+ and this was his last year
          in hockey.
        </p>
        <Figure
          left
          img={virgAndGovernorWendellAnderson}
          caption='Virg (L) with Governor Wendell Anderson of Minnesota, date unknown'
        />
        <p>
          &quot;Retire?  Why, I retired a few years ago, he always grins.  I can&apos;t do 
          that again for a while.&quot;  He was scoffed by some in the Press as an &quot;old 
          man&quot;.  Ouch!   He posed in a publicity photo with this exciting hockey 
          newcomer, Wendell Anderson.  One career was ending and the other was on the ascent. 
          &quot;Wendy&quot; Anderson was another Minnesota original.  A St. Paul native he 
          attended Johnson High School and the University of Minnesota, receiving a BA in 1954. 
          In 1960 he earned a law degree.  Like Virg, he played defense for the University of 
          Minnesota from 1951-1954 and was a member of the U.S. hockey team that won a silver 
          medal at the 1956 Winter Olympics.  He served as the Governor of Minnesota from 
          1971 to 1976.
        </p>
        <img
          className="flyingPuck"
          src={flyingPuck}
        />
      </ContentBox>


      <ContentBox type="white">
        <h2>A Farewell To All Of That</h2>
        <p>
          Virg, Fido, and Cully retired from the Black Hawks in 1945.
          Virg and Fido continued playing for the minor leagues. They also coached; Virg in the 
          Twin Cities and Rochester and Fido at the University of North Dakota. Cully went into 
          business in Seattle, WA. Cully was inducted into the U. S. Hockey Hall of Fame in 
          it&apos;s introductory year 1973, Fido and Virg were inducted in 1974.
        </p>
        <Figure
          fullWidth
          img={FidoCullyVirg}
          caption='&quot;Fido&quot; Purpur, &quot;Cully&quot; Dahlstrom, &quot;Virg&quot; Johnson Chicago 1940&apos;s'
        />
      </ContentBox>
    </PageContent>
  );
}

export default Career;
